import { Button, Text, Heading } from '@buffer-mono/popcorn'
import { fontWeightBold } from '@bufferapp/ui/style/fonts'
import { gray, grayDark } from '@bufferapp/ui/style/colors'
import HashtagGroupList from '../HashtagGroupList'

import * as Styles from './styles'
import type { HashtagGroup } from '../../types'

const emptyHeaderStyle = {
  paddingTop: '130px',
  paddingBottom: '8px',
  fontWeight: fontWeightBold,
  color: grayDark,
}

const emptyParagraphStyle = {
  color: gray,
}

interface HashtagGroupManagerProps {
  onCreateHashtagGroup: () => void
  hashtagGroups: HashtagGroup[]
  onInsertHashtagGroupClick: (name: string, text: string) => void
  onEditHashtagGroupClick: (group: HashtagGroup) => void
  onDeleteHashtagGroupClick: (group: HashtagGroup) => void
}

const HashtagGroupManager = ({
  onCreateHashtagGroup,
  hashtagGroups,
  onInsertHashtagGroupClick,
  onEditHashtagGroupClick,
  onDeleteHashtagGroupClick,
}: HashtagGroupManagerProps): JSX.Element => (
  <>
    <Heading as="h4" style={{ margin: '0 var(--space-lg)' }}>
      Hashtag Manager
    </Heading>
    {!hashtagGroups ||
      (hashtagGroups.length === 0 && (
        <Styles.EmptyWrapper>
          <div style={emptyHeaderStyle}>
            <Text as="span">No hashtag groups yet!</Text>
          </div>
          <div style={emptyParagraphStyle}>
            <Text as="span">
              Save and reuse your favorite hashtags by creating a hashtag group.
              Click the button below to get started.
            </Text>
          </div>
        </Styles.EmptyWrapper>
      ))}
    {hashtagGroups?.length > 0 && (
      <HashtagGroupList
        hashtagGroups={hashtagGroups}
        onInsertHashtagGroupClick={onInsertHashtagGroupClick}
        onEditHashtagGroupClick={onEditHashtagGroupClick}
        onDeleteHashtagGroupClick={onDeleteHashtagGroupClick}
      />
    )}
    <Styles.ButtonWrapper>
      <Button
        variant="secondary"
        onClick={onCreateHashtagGroup}
        style={{ width: '100%', justifyContent: 'center' }}
      >
        Create Hashtag Group
      </Button>
    </Styles.ButtonWrapper>
  </>
)

export default HashtagGroupManager
